export interface ChargersUtilizationSettings {
	min_daily_charge_operating_minutes: number;
	min_daily_charge_utilization: number;
	min_daily_charge_ah_utilization: number;
	min_daily_charge_kwh_utilization: number;
	max_disconnect_days: number;
	minimum_charger_daily_ahr_usage: number;
	minimum_charger_daily_kwh_usage: number;
	maximum_charger_daily_kw_demand: number;
	low_disconnect_range_min: number;
	low_disconnect_range_max: number;
	mid_disconnect_range_min: number;
	mid_disconnect_range_max: number;
	high_disconnect_limit: number;
	geofence_distance: number;
}
export interface EnergyUtilizationSettings {
	max_disconnect_days: number;
	low_disconnect_range_min: number;
	low_disconnect_range_max: number;
	mid_disconnect_range_min: number;
	mid_disconnect_range_max: number;
	high_disconnect_limit: number;
	minimum_meter_daily_kwh_usage: number;
	maximum_meter_daily_kw_demand: number;
	energy_cost: number;
	energy_demand_charge: number;
}

export interface TruckUtilizationSettings {
	min_daily_truck_operating_minutes: number;
	min_truck_utilization: number;
	min_truck_energy_utilization: number;
	deep_in_use_end_voltage_limit: number;
	num_of_deep_in_use_cycles: number;
	low_in_use_end_voltage_limit: number;
	num_of_low_in_use_cycles: number;
	geofence_distance: number;
	shift_schedule: number;
}

export interface BatteryUtilizationSettings {
	min_daily_battery_operating_minutes: number,
	min_daily_battery_utilization: number,
	min_battery_energy_utilization: number,
	min_battery_ah_return: number,
	max_battery_low_water_level_days: number,
	max_missed_weekly_wq: number,
	weak_cell_voltage_limit: number,
	no_of_inuse_cycles_with_vpc_less_weak_voltage_limit: number,
	deep_discharge_voltage_limit: number,
	no_of_inuse_cycles_with_vpc_less_deep_discharge_limit: number,
	min_finish_charge_voltage_limit: number,
	no_of_charge_cycles_with_vpc_less_min_finish_charge_voltage_limit: number,
	min_charge_event_duration: number,
	geofence_distance: number,
	low_temperature_limit: number,
	maximum_low_temperature_days: number,
	high_temperature_limit: number,
	maximum_high_temperature_days: number,
	min_daily_battery_soc: number,
	min_daily_plug_ins: number,
	min_daily_plug_time: number,
	temperature_unit: number,
	charging_type: number
}

export type UtilizationSettings = ChargersUtilizationSettings | TruckUtilizationSettings | BatteryUtilizationSettings | EnergyUtilizationSettings;

export enum UtilizationSettingType {
	Charger = 'charger_utilization_settings',
	Truck = 'truck_utilization_settings',
	Battery = 'batteries_utilization_settings',
	Energy = 'energy_utilization_settings',
}

export enum ChargerSettingsSetpValue {
	min_daily_charge_operating_minutes = 15,
	min_daily_charge_utilization = 5,
	min_daily_charge_ah_utilization = 5,
	min_daily_charge_kwh_utilization = 5,
	max_disconnect_days = 1,
	minimum_charger_daily_ahr_usage = 25,
	minimum_charger_daily_kwh_usage = 1,
	maximum_charger_daily_kw_demand = 1,
	low_disconnect_range_min = 1,
	low_disconnect_range_max = 1,
	mid_disconnect_range_min = 1,
	mid_disconnect_range_max = 1,
	high_disconnect_limit = 1,
	geofence_distance = 50,
}

export enum EnergySettingsSetpValue {
	max_disconnect_days = 1,
	low_disconnect_range_min = 1,
	low_disconnect_range_max = 1,
	mid_disconnect_range_min = 1,
	mid_disconnect_range_max = 1,
	high_disconnect_limit = 1,
	minimum_meter_daily_kwh_usage = 1,
	maximum_meter_daily_kw_demand = 1,
	energy_cost = 1,
	energy_demand_charge = 1,
}

export enum TruckSettingsStepValue {
	min_daily_truck_operating_minutes = 15,
	min_truck_utilization = 5,
	min_truck_energy_utilization = 5,
	deep_in_use_end_voltage_limit = 0.1,
	num_of_deep_in_use_cycles = 1,
	low_in_use_end_voltage_limit = 0.1,
	num_of_low_in_use_cycles = 1,
	geofence_distance = 50,
}

export enum BatteriesSettingsStepValue {
	min_daily_battery_operating_minutes = 15,
	min_daily_battery_utilization = 5,
	min_battery_energy_utilization = 5,
	min_battery_ah_return = 5,
	max_battery_low_water_level_days = 1,
	max_missed_weekly_wq = 1,
	geofence_distance = 50,
	deep_discharge_voltage_limit=0.5,
	min_daily_battery_soc=5,
	high_temperature_limit=5,
	min_daily_plug_time=5
}

export enum ChargingType {
	CONVENTIONAL = 0,
	OPPORTUNITY_FAST = 1,
}

export enum SiteTemperatureUnit {
	FAHRENHEIT = 0,
	CELSIUS = 1,
}

export enum shiftScheduleOptions {
	SINGLE_SHIFT = 8,
	TWO_SHIFTS = 16,
	THREE_SHIFTS = 24,
}